/*
  cancel_page
*/
/**
 * Desktop/Mobile CANCEL PAGE specificities
 */

//-- hide elements baded on data-cancel value
//-- CANCEL VALUE : input[data-cancel]
//-- ELEMENTS : [data-nocanceled], [data-canceled]
 if (PAGE_CODE === "prlp") {

   //-- get input with value attached to it
   var cancel_input = $("input[data-cancel]").eq(0);

   //-- if input exist
   if (cancel_input.length) {

     //-- get value
     var cancel_val = cancel_input.attr('data-cancel'); //* 1 to cast to int, easy way

     //-- hide / show corresponding elements
     if (cancel_val === 1 || cancel_val === "1") {
       $("[data-nocanceled]").hide();
       $("[data-canceled]").show();
     }
     else {
       $("[data-nocanceled]").show();
       $("[data-canceled]").hide();
     }
   }
 }
